import { getStoredUser } from '../../utils/authStorage';
import { assessmentNavigation } from './assessmentNavigation';

const draftKey = () => {
  const user = getStoredUser() || {};
  const userId = user.id || user.user_id || user.userId;
  return `assessmentSubscriptionDraft:${userId || 'current'}`;
};

const positiveId = (value) => Number.isInteger(Number(value)) && Number(value) > 0 ? Number(value) : 0;

export function normalizeAssessmentDraft(value) {
  const planId = positiveId(value?.planId);
  const durationId = positiveId(value?.durationId);
  if (!planId || !durationId) return null;
  return { planId, durationId, stateId: positiveId(value?.stateId), ...assessmentNavigation(value) };
}

export function readAssessmentDraft() {
  try {
    return normalizeAssessmentDraft(JSON.parse(window.sessionStorage.getItem(draftKey()) || 'null'));
  } catch {
    return null;
  }
}

export function saveAssessmentDraft(value) {
  const draft = normalizeAssessmentDraft(value);
  if (!draft) return;
  try {
    window.sessionStorage.setItem(draftKey(), JSON.stringify(draft));
  } catch {
    // Navigation state still allows checkout when session storage is unavailable.
  }
}
